module.exports = __webpack_public_path__ + "static/media/founder.7592b582.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/rbcx/founder.png
// module id = 9
// module chunks = 0